import Vue from "vue";
import moment from "moment";

Vue.filter("phoneMaskFormat", function (value) {
  if (value) {
    var str = value.replace(/[^0-9]/g, "");
    if (str.indexOf("02") == 0) {
      if (str.length < 10) {
        str = str.replace(/(\d{2})(\d{3})(\d{4})/, "$1-****-$3");
      } else {
        str = str.replace(/(\d{2})(\d{4})(\d{4})/, "$1-****-$3");
      }
    } else {
      if (str.length < 11) {
        str = str.replace(/(\d{3})(\d{3})(\d{4})/, "$1-****-$3");
      } else {
        str = str.replace(/(\d{3})(\d{4})(\d{4})/, "$1-****-$3");
      }
    }
    return str;
  }
});

Vue.filter("phoneFormat", function (value) {
  if (value) {
    var str = value.replace(/[^0-9]/g, "");
    if (str.indexOf("02") == 0) {
      if (str.length < 10) {
        str = str.replace(/(\d{2})(\d{3})(\d{4})/, "$1-$2-$3");
      } else {
        str = str.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
      }
    } else {
      if (str.length < 11) {
        str = str.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      } else {
        str = str.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
      }
    }
    return str;
  }
});

Vue.filter("roundFormat"),
  function (value, fixed) {
    if (fixed == null) fixed = 1;
    if (value) {
      return value.toFixed(fixed);
    }
    return value;
  };

Vue.filter("numberFormat", function (value) {
  if (value) {
    return new String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return value;
});

Vue.filter("dateFormat", function (value) {
  if (value) {
    return moment(new Date(value)).format("YYYY/MM/DD");
  }
  return value;
});

Vue.filter("dateShortFormat", function (value) {
  if (value) {
    return moment(new Date(value)).format("YY/MM/DD");
  }
  return value;
});

Vue.filter("dateMiniFormat", function (value) {
  if (value) {
    return moment(new Date(value)).format("MM/DD");
  }
  return value;
});

Vue.filter("dateTimeFormat", function (value) {
  if (value) {
    return moment(new Date(value)).format("YYYY/MM/DD HH:mm");
  }
  return value;
});

Vue.filter("dateTimeSecFormat", function (value) {
  if (value) {
    return moment(new Date(value)).format("YYYY/MM/DD HH:mm:ss");
  }
  return value;
});

Vue.filter("dateTimeShortFormat", function (value) {
  if (value) {
    return moment(new Date(value)).format("YY/MM/DD HH:mm");
  }
  return value;
});

Vue.filter("dateTimeSecShortFormat", function (value) {
  if (value) {
    return moment(new Date(value)).format("YY/MM/DD HH:mm:ss");
  }
  return value;
});

Vue.filter("fileSizeFormat", function (num) {
  if (typeof num !== "number" || isNaN(num)) {
    return "";
  }

  var exponent, unit;
  var neg = num < 0;
  var units = ["B", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  if (neg) num = -num;
  if (num < 1) return (neg ? "-" : "") + num + "B";

  exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
  unit = units[exponent];

  return (neg ? "-" : "") + num + "" + unit;
});

Vue.filter("crLfFormat", function (value) {
  if (value == null) return "";
  return value.replace(/\n/gi, "<br>");
});

Vue.filter("stripHtmlFormat", function (value) {
  var div = document.createElement("div");
  div.innerHTML = value;
  var text = div.textContent || div.innerText || "";
  return text;
});
